import React, {
    useState,
} from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTING } from 'constants/routing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faHome,
    faConciergeBell,
    faCommentDots,
    faBars,
    faChartLine, faTimes,
    faBox, faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { buildAuthLoadingSelector } from 'store/selectors/auth.selector';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import Avatar from 'components/UI/Avatar';
import { CONSTANTS } from 'services/constants';
import ThemeMode from 'components/UI/ThemeMode';
import BrandLuxuria from 'components/UI/BrandLuxuria';
import Brand from 'components/UI/Brand';
import Dialog from 'components/UI/Dialog';
import Button from 'components/UI/Button';
import { isMemberDashboard as getIsMemberDashboard } from 'utils/is-member-dashboard';

function Header({ authMember, loading, isB2cPage })
{
    const isMemberDashboard = getIsMemberDashboard();
    const [open, setOpen] = useState(false);
    const [showTravelSearch, setShowTravelSearch] = useState(false);
    const routingPath = process.env.NODE_ENV === 'development' ? 'DEV' : 'PROD';
    const isDevelopment = process.env.NODE_ENV === 'development';
    const websiteUrl = CONSTANTS.ROUTING[routingPath].UJV_WEBSITE;

    return loading || !authMember ? null : (
        <div>
            <div
                role="button"
                className="tw-fixed tw-left-[0px] tw-z-[800] lg:tw-hidden"
                onClick={() => setOpen((prevState) => (!prevState))}
                aria-hidden="true"
            >
                {!open ? (
                    <FontAwesomeIcon
                        className="tw-cursor-pointer tw-p-2 tw-w-6 tw-h-6 tw-bg-primary-darkest tw-rounded-md tw-m-2 tw-text-white"
                        icon={faBars}
                    />
                ) : (
                    <FontAwesomeIcon
                        className="tw-cursor-pointer tw-p-2 tw-w-6 tw-h-6 tw-bg-primary-darkest tw-rounded-md tw-m-2 tw-text-white"
                        icon={faTimes}
                    />
                )}
            </div>

            <div className={`tw-w-52 tw-bg-menu-background dark:tw-bg-menu-background-dark tw-text-menu-text dark:tw-text-menu-text-dark tw-fixed tw-h-screen tw-z-20 ${open ? 'tw-left-[0px]' : 'tw-left-[-300px]'} lg:tw-left-0 `}>
                <div className="tw-bg-primary-brand dark:tw-bg-primary-brand-dark tw-py-4 tw-pt-16 lg:tw-pt-4 tw-px-6 tw-text-center">
                    <a href={websiteUrl}>
                        {!isMemberDashboard && (
                            <BrandLuxuria className="tw-h-16" />
                        )}
                        {isMemberDashboard && (
                            <Brand className="tw-h-16" />
                        )}
                    </a>
                </div>
                <div className="user tw-text-center tw-flex tw-items-center tw-flex-col tw-pb-8 tw-pt-4">

                    <ThemeMode className="tw-mb-4 tw-bg-button-theme-background dark:tw-bg-button-theme-background-dark" />

                    <Avatar
                        src={authMember.member_picture}
                        alt={authMember.first_name}
                        isLoading={false}
                    />
                    {authMember && !loading ? (
                        <p className="tw-font-bold tw-font-lg">{`${authMember.first_name} ${authMember.last_name}`}</p>
                    ) : (
                        <div className="tw-animate-pulse tw-w-full">
                            <div className="tw-h-6 tw-bg-gray-200 tw-mx-auto tw-rounded-full tw-dark:bg-gray-700 tw-w-[75%]"></div>
                        </div>
                    )}
                    <a href="/sso/logout" className="tw-transition-all tw-rounded tw-text-sm tw-py-1 tw-px-5 tw-text-button-side-menu-text tw-bg-button-side-menu-background tw-font-normal tw-opacity-90 tw-mt-4 hover:tw-opacity-100">
                        SIGN OUT
                    </a>
                </div>

                <ul className="menu">
                    <ButtonList routing={ROUTING.HOME} text="Home" icon={faHome} />
                    {!isB2cPage && (<ButtonList routing={ROUTING.PROFILE} text="Profile" icon={faUser} />)}
                    <ButtonList routing={ROUTING.RESERVATIONS} text="Bookings" icon={faConciergeBell} />
                    <ButtonList routing={ROUTING.REQUESTS_MAIN} text="Quotes" icon={faCommentDots} />
                    {!isB2cPage && (<ButtonList routing={ROUTING.REPORTS} text="Reports" icon={faChartLine} />)}
                    {!isB2cPage && (<ButtonList target="_blank" routing={ROUTING.CONTENT_HUB_LINK} text="Content Hub" icon={faBox} />)}
                    {!isB2cPage && (<ButtonList target="_blank" routing={ROUTING.WHITE_LABEL_LINK} text="White Label Feature" icon={faPaperPlane} />)}
                    {!isB2cPage && (<UJVLinkButton />)}
                </ul>
                <div className="tw-text-center tw-flex tw-items-center tw-flex-col tw-pt-4">
                    {isDevelopment && (
                        <Button type="button" onClick={() => setShowTravelSearch(true)} className="tw-transition-all tw-rounded tw-text-sm tw-py-1 tw-px-5 tw-text-button-side-menu-text tw-bg-button-side-menu-background tw-font-normal tw-opacity-90 tw-mt-4 hover:tw-opacity-100">
                            Book with us!
                        </Button>
                    )}
                </div>
            </div>
            <Dialog
                model={{
                    value: showTravelSearch,
                    setter: setShowTravelSearch,
                }}
            >
                <p>
                    Travel Search goes here!
                </p>
            </Dialog>
        </div>

    );
}

function UJVLinkButton()
{
    return (
        <li className="relative px-6 py-2">
            <a href="https://www.ultimatejetvacations.com" target="_blank">
                <div className="tw-flex tw-px-6 tw-py-2 tw-items-center tw-w-full tw-text-sm tw-font-medium hover:tw-text-white hover:tw-bg-[#111111] tw-text-neutral-300 tw-bg-neutral-darker">
                    <img src="assets/favicon/favicon-32x32.png" className="tw-w-[20px] tw-h-[20px] tw-float-left " alt="UJV Website program" />
                    <div className="tw-float-left tw-mt-1 tw-ml-2"> UJV Website </div>
                </div>
            </a>
        </li>
    );
}

function ButtonList({
    icon, text, routing, target,
})
{
    return (
        <li className="relative px-6 py-3">
            <NavLink
                to={routing}
                target={target}
                className={({ isActive }) => `item tw-items-center tw-w-full  tw-px-6 tw-py-2 tw-text-sm tw-font-medium tw-flex tw-flex-wrap tw-gap-2 hover:tw-text-white ${isActive ? 'hover:tw-bg-primary-darkest tw-bg-stone-800 tw-text-neutral-100' : 'hover:tw-bg-[#111111] tw-text-neutral-300 tw-bg-neutral-darker'}`}
            >
                {icon && <FontAwesomeIcon className="tw-text-lg" icon={icon} />} {text}
            </NavLink>
        </li>
    );
}

ButtonList.propTypes = {
    text: PropTypes.string.isRequired,
    routing: PropTypes.string.isRequired,
    icon: PropTypes.object,
    target: PropTypes.string,
};
Header.defaultProps = {
    isB2cPage: false,
};
Header.propTypes = {
    isB2cPage: PropTypes.bool,
    authMember: PropTypes.object,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();
    const loadingSelector = buildAuthLoadingSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
        loading: loadingSelector(state),
    });
};

export default connect(mapStateToProps)(Header);
